module.exports = __webpack_public_path__ + "static/ec-chart-mobile-00af8b6319f748a44b5073464f2020e2.png";